// removed by extract-text-webpack-plugin
module.exports = {"root":"menu--root--1TXtX-Kd","show":"menu--show--zMpXQB9D","container":"menu--container--usaz1pkf","header":"menu--header--3nCVGYrt","Select-control":"menu--Select-control--39nHi2IP","selectControl":"menu--Select-control--39nHi2IP","user-type":"menu--user-type--iG2vbmgx","userType":"menu--user-type--iG2vbmgx"};


//////////////////
// WEBPACK FOOTER
// ./components/header/menu/styles.less
// module id = ./components/header/menu/styles.less
// module chunks = 0